module.exports = __webpack_public_path__ + "static/img/bg-index.90d1eb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingyun/bg-index.jpg
// module id = Wo8k
// module chunks = 1